import {
  backgroundMapper,
  getStringMultilocale,
} from '@quno/onboarding/src/generator/configs/componentMapper';
import {
  defaultLocale,
  localeMapper,
} from '@quno/onboarding/src/constants/locales';
import { SwipeableContainer } from '@quno/patient-journey/src/components/Container/Variants/SwipeableContainer';
import { BaseContainer } from '@quno/patient-journey/src/components/Container/BaseContainer';
import { useTranslation } from '@quno/patient-journey/src/hooks/useTranslation';
import React from 'react';
import type { ContainerTypes } from '@quno/onboarding/src/generator/types/Models';
import type { FormLocales } from '@quno/patient-journey/src/constants/locales';

type BaseProps = ContainerTypes & {
  locale: FormLocales;
  children: JSX.Element | JSX.Element[];
};

export const Base = (props: BaseProps): JSX.Element => {
  const { locale: pageLocale } = useTranslation();
  const locale = props.locale || localeMapper[pageLocale] || defaultLocale;
  const { attributes } = props ?? {};
  const { settings } = attributes ?? {};

  const scrollable = settings?.scrollable?.[defaultLocale];
  const background = backgroundMapper(attributes.background);
  const title = getStringMultilocale(attributes?.title?.title, locale);
  const titleColor = attributes?.title?.titleColor?.[defaultLocale];
  const titlePosition = attributes?.title?.titlePosition?.[defaultLocale];
  const columns = Number(settings?.numberOfColumns?.[defaultLocale]);
  const width = settings?.width?.[defaultLocale] || 'normal';
  const fontColorOverride = titleColor;

  const Container = scrollable ? SwipeableContainer : BaseContainer;

  return (
    <Container
      {...{
        columns,
        width,
        scrollable: !!scrollable,
        fontColorOverride,
        title,
        titleAlignment: titlePosition,
        ...background,
      }}
    >
      <>{props.children}</>
    </Container>
  );
};
